module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av1-c9ec322605978bfd1e3b97c218a66d91.jpg";